export default {
  serverBaseUrl: process.env.VUE_APP_BASE_URL,
  ApiBaseUrl: process.env.VUE_APP_MIT_API_URL,
  debtiaappUrl: process.env.VUE_APP_API_URL,
  economicRedirectUrl: process.env.VUE_APP_ECONOMIC_REDIRECT_URL,
  dineroRedirectUrl: process.env.VUE_APP_DINERO_REDIRECT_URL,
}
